<template>
  <div class="dialog_box">
    <el-dialog
      title="凭证上传"
      :visible="show"
      width="437px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_container">
        <div class="voucher_title_box">
          <div class="voucher_title_1">*</div>
          <div class="voucher_title_2">工单凭证</div>
          <div class="voucher_title_3">
            请上传png、jpg格式的图片，且不超过20Mb
          </div>
        </div>
        <div class="upload_content">
          <div class="upload_box">
            <div class="upload_title">现场照片</div>
          </div>
          <div class="upload_img">
            <el-upload
              action=""
              :limit="5"
              ref="sceneUpload"
              class="upload-demo"
              :file-list="sceneList"
              :http-request="sceneUploadFile"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              show-file-list
              list-type="picture-card"
              :on-exceed="onExceedCHange"
            >
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }" class="file_box">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.filePath"
                  alt
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, sceneList)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="upload_content">
          <div class="upload_box">
            <div class="upload_title">施工照片</div>
          </div>
          <div class="upload_img">
            <el-upload
              action=""
              :limit="5"
              ref="constructionUpload"
              class="upload-demo"
              :file-list="constructionList"
              :http-request="constructionUploadFile"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              show-file-list
              list-type="picture-card"
              :on-exceed="onExceedCHange"
            >
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }" class="file_box">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.filePath"
                  alt
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, constructionList)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="upload_content">
          <div class="upload_box">
            <div class="upload_title">维修清单</div>
          </div>
          <div class="upload_img">
            <el-upload
              action=""
              :limit="5"
              ref="maintainUpload"
              class="upload-demo"
              :file-list="maintainList"
              :http-request="maintainUploadFile"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              show-file-list
              list-type="picture-card"
              :on-exceed="onExceedCHange"
            >
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }" class="file_box">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.filePath"
                  alt
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, maintainList)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="upload_content">
          <div class="upload_box">
            <div class="upload_title">费用凭证</div>
          </div>
          <div class="upload_img">
            <el-upload
              action=""
              :limit="5"
              ref="costUpload"
              class="upload-demo"
              :file-list="costList"
              :http-request="costUploadFile"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              show-file-list
              list-type="picture-card"
              :on-exceed="onExceedCHange"
            >
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }" class="file_box">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.filePath"
                  alt
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, costList)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="upload_content">
          <div class="upload_box">
            <div class="upload_title">签字凭证</div>
          </div>
          <div class="upload_img">
            <el-upload
              action=""
              :limit="5"
              ref="signatureUpload"
              class="upload-demo"
              :file-list="signatureList"
              :http-request="signatureUploadFile"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              show-file-list
              list-type="picture-card"
              :on-exceed="onExceedCHange"
            >
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }" class="file_box">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.filePath"
                  alt
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file, signatureList)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm">提 交</el-button>
      </span>
    </el-dialog>
    <preview-image
      :show.sync="dialogVisible"
      :name="dialogImageName"
      :path="dialogImageUrl"
    />
  </div>
</template>

<script>
import previewImage from "@/components/previewImage.vue";
import { downloadFile, removeImage } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      form: {},
      imgUrl: "../../../../static/images/idCard_icon.png",
      sceneList: [], // 现场照片
      constructionList: [], // 施工照片
      maintainList: [], // 维修照片
      costList: [], // 费用凭证
      signatureList: [], // 签字凭证
      idsList: [],
      headers: {},
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false,
    };
  },
  components: {
    previewImage,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.idsList = [];
        this.sceneList = [];
        this.constructionList = [];
        this.maintainList = [];
        this.costList = [];
        this.signatureList = [];
        let params = {
          page: 1,
          limit: 10000,
          type: "凭证上传",
          linkedId: this.data.id,
        };
        this.$http.selectFile(params).then((res) => {
          if (res.code === 0) {
            res.data.forEach((i) => {
              this.idsList.push(i.fileId);
              if (i.fileName == "现场照片") {
                this.sceneList.push(i);
              } else if (i.fileName == "施工照片") {
                this.constructionList.push(i);
              } else if (i.fileName == "维修清单") {
                this.maintainList.push(i);
              } else if (i.fileName == "费用凭证") {
                this.costList.push(i);
              } else if (i.fileName == "签字凭证") {
                this.signatureList.push(i);
              }
            });
          }
        });
      }
    },
  },
  created() {
    this.headers = {
      Authorization: sessionStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
  },
  methods: {
    dialogClose() {
      this.$emit("update:show", false);
    },
    confirm() {
      console.log(this.idsList);
      if (
        this.sceneList.length === 0 ||
        this.constructionList.length === 0 ||
        this.maintainList.length === 0 ||
        this.costList.length === 0 ||
        this.signatureList.length === 0
      ) {
        return this.$message.info("每种类型的照片最少上传一张");
      } else {
        this.$http
          .confirmPic({ ids: this.idsList, orderId: this.data.id })
          .then((res) => {
            if (res.code === 0) {
              this.idsList = [];
              this.sceneList = [];
              this.constructionList = [];
              this.maintainList = [];
              this.costList = [];
              this.signatureList = [];
              this.$parent.getList();
              this.$emit("update:show", false);
              this.$message.success(res.msg);
            } else {
              this.$message.error("上传失败，请稍后再试！");
            }
          });
      }
    },
    // 现场照片 上传
    sceneUploadFile(file) {
      console.log("file", file);
      console.log(this.data);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("type", "凭证上传");
      formData.append("fileName", "现场照片");
      formData.append("datePath", `/凭证上传/${this.data.id}/现场照片/`);
      this.$http.uploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.sceneList.push({
            filePath: res.data.filePath,
            fileId: res.data.fileId,
            fileName: res.data.fileName,
          });
          this.idsList.push(res.data.fileId);
        } else {
          this.$message.error("上传失败，请稍后再试！");
        }
      });
    },
    // 施工照片 上传
    constructionUploadFile(file) {
      console.log("file", file);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("type", "凭证上传");
      formData.append("fileName", "施工照片");
      formData.append("datePath", `/凭证上传/${this.data.id}/施工照片/`);
      this.$http.uploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.constructionList.push({
            filePath: res.data.filePath,
            fileId: res.data.fileId,
            fileName: res.data.fileName,
          });
          this.idsList.push(res.data.fileId);
        } else {
          this.$message.error("上传失败，请稍后再试！");
        }
      });
    },
    // 维修清单
    maintainUploadFile(file) {
      console.log("file", file);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("type", "凭证上传");
      formData.append("fileName", "维修清单");
      formData.append("datePath", `/凭证上传/${this.data.id}/维修清单/`);
      this.$http.uploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.maintainList.push({
            filePath: res.data.filePath,
            fileId: res.data.fileId,
            fileName: res.data.fileName,
          });
          this.idsList.push(res.data.fileId);
        } else {
          this.$message.error("上传失败，请稍后再试！");
        }
      });
    },
    // 费用凭证
    costUploadFile(file) {
      console.log("file", file);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("type", "凭证上传");
      formData.append("fileName", "费用凭证");
      formData.append("datePath", `/凭证上传/${this.data.id}/费用凭证/`);
      this.$http.uploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.costList.push({
            filePath: res.data.filePath,
            fileId: res.data.fileId,
            fileName: res.data.fileName,
          });
          this.idsList.push(res.data.fileId);
        } else {
          this.$message.error("上传失败，请稍后再试！");
        }
      });
    },
    // 签字凭证
    signatureUploadFile(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("type", "凭证上传");
      formData.append("fileName", "签字凭证");
      formData.append("datePath", `/凭证上传/${this.data.id}/签字凭证/`);
      this.$http.uploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.signatureList.push({
            filePath: res.data.filePath,
            fileId: res.data.fileId,
            fileName: res.data.fileName,
          });
          this.idsList.push(res.data.fileId);
        } else {
          this.$message.error("上传失败，请稍后再试！");
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png";
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
    onExceedCHange() {
      return this.$message.info("最多只能上传5张相应的照片");
    },
    handleRemove(file, list) {
      removeImage(file, list, this.idsList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.filePath;
      this.dialogImageName = file.fileName;
      this.dialogVisible = true;
    },
    scenedPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.filePath;
      this.dialogImageName = file.fileName;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      downloadFile(file.filePath, file.fileName);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
</style>



// WEBPACK FOOTER //
// src/views/workOrder_Admin/component/voucher.vue